import { Feature, useFeatureFlag } from '../../../../../context/useFeatureFlag'
import { useTransactionPriceQuery } from '../../../../../graphql/generated/graphql'

export const useAmountWithFee = (amount: string) => {
    const pricingEnabled = useFeatureFlag(Feature.Pricing)
    const { data: transactionPriceQuery } = useTransactionPriceQuery({
        skip: !pricingEnabled || !amount,
        nextFetchPolicy: 'cache-first',
        variables: {
            amount: Number(amount),
        },
    })

    const feeAmount = transactionPriceQuery?.transactionPrice ?? 0

    return Number(amount) + feeAmount
}
